<pp-advanced-filter-option-select
  class="advancedFilter__option"
  [ppItems]="advancedFilterMultiListOptions"
  [ppOption]="option"
  (ppOptionChange)="changeFieldCondition($event)"
  ppClass="advancedFilter__option--condition"
></pp-advanced-filter-option-select>

@if (
  option &&
  option !== EAdvancedFilterOptions.IS_EMPTY &&
  option !== EAdvancedFilterOptions.IS_NOT_EMPTY
  ) {
  <pp-advanced-filter-multi-list-input
    [ppField]="field"
    [ppSelected]="value"
    (ppSelectCf)="changeFieldValue($event)"
  ></pp-advanced-filter-multi-list-input>
}
